import * as React from 'react'
import type MouseStates from '../../utils/MouseStates.js'

import './styles.css'

const classNames = require('classnames');

type PropsType = {
  MouseStates: MouseStates,
  isFirstPlane: boolean,
  DetailView: boolean
}

export default class Mouse extends React.Component<PropsType> {
  constructor(props) {
    super(props);

    this.points = [];
    this.mouseRadius = React.createRef();
    this.indexSelected = -1;
    this.mouseDown = false;
    this.onNavbar = false;
    this.activeOneTime = false;

    this.state = {
      positions: { x: 0, y: 0 },
      detailHover: false,
      isStuck: false,
      onLeave: false,
      graphicMouse: "",
      labelText: "",
      isOnButton: false,
      clickOnButton: false,
      colored: false,
    }
  }

  fetchPoints() {
    return document.getElementsByClassName('detail-point');
  }

  componentDidMount() {
    this.points = this.fetchPoints(); // Fetch all data
    this.handleEventListeners();
  }


  handleEventListeners() {
    window.addEventListener('mousemove', (e) => this.onMouseMove(e));
    window.addEventListener('click', () => this.handleClickEvent());
    window.addEventListener('mousedown', (e) => this.onMouseDown(e));
    window.addEventListener('mouseup', (e) => this.onMouseUp(e));
  }

  onMouseMove(e) {
    // if(!this.act
    if(this.mouseDown) {
      this.setState({positions: { x: e.clientX, y: e.clientY }});
      return;
    }
    
    this.handleMouseAppearance(e.target);
    
    this.setState({positions: { x: e.clientX, y: e.clientY }});
    
    this.onMouseRadius();


    if(this.indexSelected === -1) this.eventsOff()

    if (!this.state.isStuck && this.state.onLeave) {
      setTimeout(() => {
        this.setState({onLeave : false})
      }, 100);
    }
  }

  onMouseUp(e) {
    this.mouseDown = false;
    this.onMouseMove(e);
  }

  onMouseDown(e) {
    this.mouseDown = true;

    if(e.target.classList.toString().match(/navbar-dot/)) return;

    if(e.target.classList.toString().match(/navbar-slider|navbar-body/)) {

      this.setState({
        graphicMouse: 'timeline-mouse',
        labelText: ''
      })
    }
  }

  handleCursorOnDotNoMove(e) {

    if(!e.target.classList.toString().match(/navbar-dot/)) return;

    requestAnimationFrame(this.handleCursorOnDotNoMove(e));
    // this.handleMouseAppearance(e);
  }

  
  
  // Handle The Mouse Appearance
  handleMouseAppearance(target) {

    const targetClassList = target.classList.toString();
  // @EXPLAINATION : If the article is not set yet
    // if(this.props.MouseStates.hoverPlane && !this.props.MouseStates.showArticle) {
      // console.info('plane');
    if(!targetClassList.match(/loader-container/)) {
      
      if(this.props.MouseStates.hoverPlane && !this.props.MouseStates.showArticle && !targetClassList.match(/btn-container|navbar-slider|navbar-body|navbar-dot|about-btn|about-wrapper|social-network-icon|logo-about/)){
          this.setState({graphicMouse: 'drag-mouse'})
          this.setState({labelText: 'Click to reveal the daily image'})
          return;
      } else {
        // @EXPLAINATION : If the detail page is showed = Disable rollover on left side but close button
        if(this.props.MouseStates.getDetailPage()) {
          if(!targetClassList.match(/quit-btn|change-btn/) && targetClassList.match(/(information-title|information-location|location-and-networks|information-wrapper|btn-container|photographer-name)/)) {
            return;
          }
        }

        if(targetClassList.match(/(detail-info-container|read-more|detail-point)/) && this.props.MouseStates.getDetailPage()) {
          this.setState({
            graphicMouse: 'close-mouse',
            labelText: 'Close'
          });
        }
        else if(targetClassList.match(/(back-btn|logo|about-btn|btn-container|action|photographer-name|quit-btn|social-network-container|social-network-icon|responsive-pic|link-underline|instagram-wrapper|quit-btn|change-btn)/)) {
          this.setState({
            isOnButton: true,
            labelText: '',
            detailHover: false,
            graphicMouse: 'onButton-mouse',
            clickOnButton: false,
          });
          if(targetClassList.match(/brown/)) this.setState({colored: true});
        }
        else if(targetClassList.match(/(navbar-dot|navbar-selected)/)) {
        // else if(targetClassList.match(/(navbar-body|navbar-dot|navbar-selector|navbar-selected)/)) {
          this.setState({
            graphicMouse: 'timeline-mouse',
            labelText: ''
          })
        } 
        else if(targetClassList.match(/photographer-portfolio|fs-container|fs-image/)) {
          this.setState({
            graphicMouse: 'colored-mouse',
            labelText: ''
          })
        }
        else {
          this.handleMouseAppearanceToNone();
        }
      }
    } else {
      this.handleMouseAppearanceToNone();
    }
  }


  handleClickEvent() {
    if(this.state.graphicMouse === "timeline-mouse" || this.state.graphicMouse === "drag-mouse") return;

    if(this.indexSelected !== -1 && !this.props.MouseStates.getDetailPage()) {
      this.points[this.indexSelected].click();
      this.props.MouseStates.enabledDetailPage();
      this.setState({isStuck: false});
      this.props.MouseStates.setShowArticle(true);
    }

    if(this.state.graphicMouse === 'onButton-mouse') {
      this.setState({clickOnButton : true}) 
    } else {
      this.handleMouseAppearanceToNone();
      this.eventsOff();
    }

  }

  handleMouseAppearanceToNone() {
    if(!this.onNavbar) {
      this.setState({
        graphicMouse: '',
        labelText: '',
        clickOnButton: false,
        colored: false
      });
    }
  }
  

  // @EXPLAINATION : Sticky on detail point
  eventsOn(el, elPositions) {
    if(!this.props.MouseStates.getDetailPage()) {
      this.setState({
        isStuck: true,
        detailHover: true,
        positions: {x: elPositions.x + el.clientWidth / 2, y: elPositions.y + el.clientHeight / 2 },
        labelText: 'More details'
      });
      this.props.MouseStates.triggerOnAnimation();
      this.props.MouseStates.setCurrentDotTitle(el.dataset.currenttitle, el);
    } else {
      this.eventsOff();
    }
  }

  // @EXPLAINATION : Sticky off detail point
  eventsOff() {
    if(!this.props.MouseStates.getDetailPage()) {
      this.setState({
        isStuck: false,
        onLeave: true,
        detailHover: false
      });

      this.props.MouseStates.triggerOffAnimation();
      this.props.MouseStates.setCurrentDotTitle();    
    }
  }

  // @EXPLAINATION : Define the radius to stick to the detail point
  onMouseRadius() {
    if (this.points.length > 0) {
      this.indexSelected = -1;
      for (let i = 0; i < this.points.length; i += 1) {
        const el = this.points[i];
        const elPositions = this.points[i].getBoundingClientRect();
        const _mouseRadius = this.mouseRadius.current;
        const mousePositions = this.state.positions;

        if(mousePositions.x - _mouseRadius.clientWidth / 2 <= elPositions.x + el.clientWidth / 2 && mousePositions.x - _mouseRadius.clientWidth / 2 + _mouseRadius.clientWidth >= elPositions.x + el.clientWidth / 2){
          if(mousePositions.y  - _mouseRadius.clientHeight / 2 <= elPositions.y + el.clientHeight / 2 && mousePositions.y - _mouseRadius.clientHeight / 2 + _mouseRadius.clientHeight >= elPositions.y + el.clientHeight / 2){ 
                this.eventsOn(el, elPositions);
                this.indexSelected = i;
          } 
        } 
      }
    } 
  }

  
  render() {
    const mouseWrapperClass = classNames({
      'mouse-cursor': true,
      'stuck': this.state.isStuck,
      'onLeave': this.state.onLeave,
    })
    const mouseClass = classNames({
      'mouse-graphic': true,
      'detail-hover': (this.state.detailHover || this.state.isStuck) && !this.props.MouseStates.getDetailPage(),
      'close-mouse': this.state.graphicMouse === 'close-mouse',
      'onButton-mouse': this.state.graphicMouse === 'onButton-mouse',
      'clickOnButton': this.state.clickOnButton,
      'drag-mouse': this.state.graphicMouse === 'drag-mouse',
      'timeline-mouse': this.state.graphicMouse === 'timeline-mouse',
      'colored-mouse': this.state.graphicMouse === 'colored-mouse',
      'colored': this.state.colored
    });
    const mouseLabelClass = classNames({
      'mouse-label': true,
      'show': this.state.isStuck || this.state.graphicMouse === 'close-mouse' || this.state.graphicMouse === 'drag-mouse',
    })

    return (
      <div ref={ this.mouseRadius } className={ mouseWrapperClass } style={{ transform: `translate(${this.state.positions.x}px, ${this.state.positions.y}px)` }}>
        <div className={ mouseClass }></div>
        <div className="mouse-text">
          <span className={ mouseLabelClass }>{this.state.labelText}</span>
        </div>
      </div>
    );
  }
} 


// WEBPACK FOOTER //
// ./src/components/Mouse/index.jsx